// extracted by mini-css-extract-plugin
export default {"chart-type-selector":"P_fX"};